"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var classNames = require('classnames');
var CalloutEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(CalloutEmbed, _super);
    function CalloutEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalloutEmbed.prototype.render = function () {
        var classes = classNames('callout-embed', { 'callout-embed--narrow': this.props.narrow });
        return (React.createElement("div", { className: classes, style: { backgroundImage: "url(" + this.props.backgroundImage + ")" } },
            React.createElement("a", { href: this.props.href },
                React.createElement("h1", { className: "callout-embed__title" }, this.props.title),
                React.createElement("div", { className: "callout-embed__action" }, I18n.t('discovery.calloutEmbed.shopNow')))));
    };
    return CalloutEmbed;
}(React.Component));
exports.default = CalloutEmbed;
//# sourceMappingURL=callout_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/callout_embed.js
// module id = YDDt
// module chunks = 20 21